import { defaultFill } from '../../../../utils/constants';
var muiPlayCircleOutline16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M6.14524695,5.12515761 C6.3375278,4.95805898 6.65039428,4.95903024 6.83973705,5.12357558 L6.83973705,5.12357558 L10.5766633,7.47241943 C11.0415282,7.76461012 11.04023,8.23611825 10.5766633,8.52738488 L10.5766633,8.52738488 L6.83973705,10.8753575 C6.64846161,11.0415824 6.33886834,11.042039 6.14524695,10.8737754 C6.04954321,10.7906056 6.00175086,10.681475 6.00123201,10.5725413 C6.00074333,10.469942 6.00387604,6.18079582 6.0009952,5.52481666 L6.00028232,5.44270915 C5.99583187,5.32870913 6.04399147,5.21315208 6.14524695,5.12515761 Z',
            fill: defaultFill,
        },
    ],
    title: 'Play',
    width: 16,
    height: 16,
};
var muiPlayCircleOutline = {
    base: muiPlayCircleOutline16,
    smIcon: muiPlayCircleOutline16,
};
export { muiPlayCircleOutline };
//# sourceMappingURL=playCircleOutline.js.map